'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@petsmart-ui/sparky';
import { type KeyboardEvent, type MouseEvent, type PropsWithChildren } from 'react';
function stopHostPropagation(event: MouseEvent | KeyboardEvent) {
  event.stopPropagation();
}
export function StackedDrawerBoundary(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div role="presentation" onClick={stopHostPropagation} onKeyDown={stopHostPropagation}>{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
type StackedDrawerBackButtonProps = {
  className: string;
  testId: string;
  onClick: (event: MouseEvent) => void;
};
export function StackedDrawerBackButton(t0) {
  const $ = _c(5);
  const {
    className,
    testId,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon name="chevron-left" size="lg" aria-hidden="true" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className || $[2] !== onClick || $[3] !== testId) {
    t2 = <button type="button" aria-label="Back" className={className} data-testid={testId} onClick={onClick}>{t1}</button>;
    $[1] = className;
    $[2] = onClick;
    $[3] = testId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}